const nativeFetch = window.fetch.bind(window);

function isGameApiRequest(input) {
  const target = typeof input === 'string' ? input : input?.url;
  const apiRoot = process.env.REACT_APP_API_URL;
  return Boolean(target && apiRoot && target.startsWith(apiRoot));
}

export function installAuthenticatedFetch() {
  window.fetch = (input, init = {}) => {
    if (!isGameApiRequest(input)) return nativeFetch(input, init);

    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    const initData = window.Telegram?.WebApp?.initData;
    if (initData) headers.set('X-Telegram-Init-Data', initData);

    if (process.env.REACT_APP_ENABLE_DEV_AUTH === 'true' && !initData) {
      headers.set('X-Dev-Username', process.env.REACT_APP_DEV_USERNAME || 'local_dev');
    }
    return nativeFetch(input, { ...init, headers });
  };
}
